import React, { useState, useEffect } from "react";
import "../../Styles/Modal.css";
import { getData, clearAllData } from "../../utils/store-data";
import { USER_ID } from "../../utils/store-data-constants";
import { delete_profile, delete_user_account } from "../../api/serverWrapper";
import { useNavigate } from "react-router-dom";

function CloseAccountModal({ isOpen, onClose, onDisable, isProfile }) {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setSuccessMsg(false);
      setErrorMsg("");
      setIsLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleDeleteAccount = async () => {
    try {
      setIsLoading(true);
      setErrorMsg("");

      const UserId = await getData(USER_ID);

      const resp = await delete_user_account({
        UserId,
      });

      console.log(resp);

      if (resp?.code === 200) {
        setSuccessMsg(true);

        if(isProfile){
          handleDelete();
        }

        setTimeout(async () => {
          await clearAllData();
          navigate("/home");
        }, 2000);
      } else {
        setErrorMsg(
          resp?.message || "Failed to delete account. Please try again.",
        );
      }
    } catch (error) {
      console.log(error);

      setErrorMsg(error?.message || "Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (client) => {
    try {
      const data = {
        ProfileId: isProfile.ProfileId,
        IsDeleted: true,
      };

      const resp = await delete_profile(data);

      console.log("Profile deleted successfully:", resp);
    } catch (error) {
      console.error("Error deleting profile:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="confirm-modal">
        {successMsg ? (
          <>
            <h2>Account Deleted</h2>

            <p>
              Your account has been deleted successfully.
              <br />
              Redirecting to home page...
            </p>
          </>
        ) : (
          <>
            <button
              className="modal-close-btn"
              onClick={onClose}
              disabled={isLoading}
            >
              ✕
            </button>

            <h2>Are you sure you want to Close your account?</h2>

            <p>
              Closing your account will delete all data permanently. If needed,
              you can disable the profile instead and reactivate it later.
            </p>

            {errorMsg && (
              <div
                style={{
                  color: "red",
                  marginBottom: "15px",
                  textAlign: "center",
                }}
              >
                {errorMsg}
              </div>
            )}

            <div className="modal-actions">
              <button
                className="disable-btn"
                onClick={onDisable}
                disabled={isLoading}
              >
                Disable
              </button>

              <button
                className="delete-btn"
                onClick={handleDeleteAccount}
                disabled={isLoading}
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>

              <button
                className="cancel-btn"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CloseAccountModal;
